module.exports = __webpack_public_path__ + "mail.7ba322ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/mail.png
// module id = 842
// module chunks = 0